import { render, staticRenderFns } from "./ServerInstance.vue?vue&type=template&id=7363d345&scoped=true&lang=pug"
import script from "./ServerInstance.vue?vue&type=script&lang=js"
export * from "./ServerInstance.vue?vue&type=script&lang=js"
import style0 from "./ServerInstance.vue?vue&type=style&index=0&id=7363d345&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363d345",
  null
  
)

export default component.exports